import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import GetStartedPage from './pages/GetStartedPage';
import Layout from 'components/Layout';
import PodcastEditor from './pages/PodcastEditor';
import GeneratedPodcast from './pages/GeneratedPodcast';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setResponse } from 'store/slices/podcastResponse';

const PodCast = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { data } = useSelector((state: RootState) => state.podcastRes);

  // Check for saved podcast state when component mounts
  useEffect(() => {
    if (isAuthenticated && data.dialogues.length === 0) {
      const savedPodcast = localStorage.getItem('pending_podcast');
      if (savedPodcast) {
        try {
          const parsedPodcast = JSON.parse(savedPodcast);
          // Restore the podcast state to Redux
          dispatch(
            setResponse({
              success: true,
              message: 'Restored from saved session',
              data: { dialogues: parsedPodcast.dialogues }
            })
          );
        } catch (error) {
          console.error('Failed to parse saved podcast state:', error);
        }
      }
    }
  }, [isAuthenticated, data.dialogues.length, dispatch]);

  return (
    <Layout>
      <Routes>
        {/* Get Started */}
        <Route path="/get-started" element={<GetStartedPage />} />
        {/* page after generation of podcast */}
        <Route path="/view-podcast" element={<PodcastEditor />} />
        {/* Show Generated Podcast */}
        <Route path="/generated" element={<GeneratedPodcast />} />
      </Routes>
    </Layout>
  );
};

export default PodCast;
